<div class="position-relative">
    <div id="games_schedule_title" class="glaeSegmentHeader" [ngClass]="{ 'legacy-styles-section': isCxone }" cvLocalizedText langSection="Games" langKey="Schedule_Component_Title">When would you like the game to run?</div>    
    <p id="games_schedule_repeat" class="mb-1 mt-3" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" cvLocalizedText langSection="Games" langKey="Schedule_Component_Repeat">Repeat After Every</p>    
    <div class="btn-group radio-based">
        <label class="btn btn-secondary btn-sm" [ngClass]="getButtonClass('0')" (click)="setScheduleInterval('0')" cvLocalizedText langSection="Objectives" langKey="Daily">Daily</label>
        <label class="btn btn-secondary btn-sm" [ngClass]="getButtonClass('1')" (click)="setScheduleInterval('1')" cvLocalizedText langSection="Objectives" langKey="Weekly">Weekly</label>
        <label class="btn btn-secondary btn-sm" [ngClass]="getButtonClass('2')" (click)="setScheduleInterval('2')" cvLocalizedText langSection="Objectives" langKey="Monthly">Monthly</label>
    </div>
    <p id="games_schedule_instructions_2" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" class="mt-4 mb-1" cvLocalizedText langSection="Games" langKey="Schedule_Component_Interval_Begin_End">When would you like to schedule these intervals to begin and end?</p>

    <div class="d-flex pt-2">
        <div>
            <div cvLocalizedText langSection="Games" langKey="Start" [ngClass]="{ 'legacy-styles-body-default': isCxone }">Start</div>
            <div class="input-group">
                <div class="search-box click-search justify-content-start">
                    <cv-baremetrics-calendar class="d-block daterange daterange--single baremetrics-date-picker" 
                        mode="single"
                        [required]="true" 
                        [placeholder]="datePlaceHolder()"
                        [(currentDate)]="schedule.StartDate"
                        (dateChanged)="handleStartDateChanged($event)"
                        (mouseenter)="removeContentEditable($event)">
                    </cv-baremetrics-calendar>
                </div>
            </div>
        </div>
        <div class="mx-3 mt-4" [ngClass]="{ 'legacy-styles-body-default': isCxone }" cvLocalizedText id="schedule_component_to" langSection="Games" langKey="Schedule_Component_To">to</div>
        <div>
            <div cvLocalizedText [ngClass]="{ 'legacy-styles-body-default': isCxone }" langSection="Games" langKey="End">End</div>
            <div class="input-group">
                <div class="search-box click-search justify-content-start">
                    <cv-baremetrics-calendar class="d-block daterange daterange--single baremetrics-date-picker"
                        [ngClass]="{'baremetrics-disabled': schedule.Ongoing}" 
                        mode="single"
                        [required]="false" 
                        [placeholder]="datePlaceHolder()" 
                        [(currentDate)]="schedule.EndDate"
                        (mouseenter)="removeContentEditable($event)"
                        [earliestDate]="earliestDate"
                        >
                    </cv-baremetrics-calendar>
                </div>
            </div>
        </div>
        <div class="ml-4 pl-2 mt-3 pt-2">
            <div class="d-flex flex-row checkbox">
                <input id="checkboxOngoing" class="form-check-input align-text-bottom" type="checkbox" [(ngModel)]="schedule.Ongoing" (ngModelChange)="ongoingChanged()" />
                <label class="form-check-label ml-2" [ngClass]="{ 'legacy-styles-body-default': isCxone }" for="checkboxOngoing" cvLocalizedText langSection="Games" langKey="Schedule_Component_Ongoing">Ongoing</label>
            </div>
        </div>
    </div>    

    <p id="schedule_component_run_details" class="font-size-12 mb-0 mt-3" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" cvLocalizedText langSection="Games" langKey="Schedule_Component_Run_Details">
        Games will begin at 12:00 AM on the start date and go until 11:59 PM on the end date.
    </p>
</div>